import { render } from "./AiDetectorProtocolForm.vue?vue&type=template&id=743200ac&ts=true"
import script from "./AiDetectorProtocolForm.vue?vue&type=script&lang=ts"
export * from "./AiDetectorProtocolForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__